import DocumentTypeRowWithDescription from './DocumentTypeRowWithDescription'

export default DocumentTypeRowWithDescription
